// AppHeader.js
import React from 'react';
import { styled  } from '@mui/material/styles';
import {useReactiveVar} from '@apollo/client';
import { Box } from '@mui/system';
import { AppNumber, AppPalette } from '../../model/AppConst';
import AppMenuInHeader from '../menu/AppMenuInHeader';
import { currentMenuRepo } from '../../model/CvoModel'; // {signedIn:bool, user:{}, userAs:{}}
import HelpButton from '../help/HelpButton';

const HeaderContainer = styled(Box)({
    width: '100%',
    height: AppNumber.HeaderHeight,
    verticalAlign:'bottom',
    overflow:"hidden",
    position:"fixed",
    top:0,left:0,
    backgroundColor:AppPalette.HeaderBackground,
    color:"#e8eadb",
});

const HeaderRow = styled(Box)({
    marginTop:10, verticalAlign:'bottom',
    position: "absolute",
    left:0, bottom: 0, right:0
});
const LogoBox = styled(Box)({
    display:"inline-block", fontSize:"32pt", color:"white",
    verticalAlign:'bottom',
    paddingLeft: 30, marginRight: 20,
    fontStyle:"italic", fontWeight:"bold"
});
const TitleBox = styled(Box)({
    display:"inline-flex", alignItems:"center",
    fontSize:"18pt", fontWeight:"bold",
    textAlign:"left",
    paddingLeft: 30,
    paddingBottom: 10,
});

export default function AppHeader({onClickMenuInHeader}) {
    const menuInfo = useReactiveVar(currentMenuRepo);

    const onClickHeaderMenu = () => {onClickMenuInHeader()};

    return (
        <HeaderContainer>
            <HeaderRow>
                <LogoBox>
                    <span style={{color:'#9f9'}}>e</span>Trace
                    <div style={{
                            fontSize: '0.55rem',
                            color: '#ccc',
                            textAlign: 'right',
                            paddingRight: 10,
                        }}
                    >
                        Version. {process.env.REACT_APP_VERSION}
                    </div>
                </LogoBox>
                <TitleBox >
                    <span style={{marginRight: 10}}>{menuInfo.menuName}</span>
                    <HelpButton />
                </TitleBox>
                <AppMenuInHeader
                    onClick={onClickHeaderMenu} />
            </HeaderRow>
        </HeaderContainer>
    );
}
